import React from "react"

import { useParams } from "react-router-dom"

import { PoliciesListType } from "@common-shared/config/oneVerify/oneVerifyPolicies.config"
import { OneVerifyPermission } from "@common-shared/config/rolesPermissions.config"

import { useScrollFix } from "@front-shared/hooks/scrollFix.hook"

import { useHasPermissions } from "../../../hooks/hasPermissions.hook"
import { NotFoundComponent } from "../../general/notFound.component"
import { SinglePolicyViewComponent } from "./singlePolicyView.component"

export const SinglePolicyPlanYearResetsComponent: React.FunctionComponent =
    () => {
        useScrollFix()

        useHasPermissions([OneVerifyPermission.viewPlanYearResets])

        const { nirvanaRequestId } = useParams()

        return nirvanaRequestId ? (
            <div className="relative">
                <SinglePolicyViewComponent
                    nirvanaRequestId={nirvanaRequestId}
                    listType={PoliciesListType.PLAN_YEAR_RESETS}
                />
            </div>
        ) : (
            <NotFoundComponent />
        )
    }
